/**
 * Component to register Australia Post
 *
 * @component
 */

import React from 'react';
import { Modal, Input, message, Row, Col, Divider, Button, Select } from 'antd';
import axios from 'axios';
import { trackingVitally } from '../../../../../helpers/vitally';
import { AUSPOST_PRODUCT_SET } from '../../../../../constants/constants';

const LABEL_SERVICE = 'auspost';
class AuspostModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      active: false,
      labelAccountNumber: null,
      labelApiKey: null,
      labelPassword: null,
      loading: false,
      auspostProductSet: null,
      auspostMerchantToken: null,
    };
  }

  async componentDidMount() {
    try {
      const response = await axios.get(`/api/carrierSettings/${LABEL_SERVICE}`);
      if (response.data) {
        const { carrier } = response.data;
        this.setState({
          id: carrier.id,
          active: carrier.active,
          labelApiKey: carrier.labelApiKey,
          labelPassword: carrier.labelPassword,
          labelAccountNumber: carrier.labelAccountNumber,
          auspostProductSet:
            carrier.auspostProductSet || AUSPOST_PRODUCT_SET.PARCEL_CONTRACT_PRODUCTS,
          auspostMerchantToken: carrier.auspostMerchantToken,
        });
      }
    } catch (err) {
      if (err.response.status !== 404) {
        console.log(err);
        message.error('something went wrong please try again', 5);
      }
    }
  }

  validateFields = () => {
    const auspostProductSet = this.state.auspostProductSet,
      labelApiKey = this.state.labelApiKey,
      labelAccountNumber = this.state.labelAccountNumber,
      labelPassword = this.state.labelPassword,
      auspostMerchantToken = this.state.auspostMerchantToken;
    if (!auspostProductSet) {
      message.error('Please select a product set.');
    }
    if (!labelApiKey || labelApiKey === '') {
      message.error('API Key is required.');
      return false;
    }
    if (
      (!labelAccountNumber || labelAccountNumber === '') &&
      auspostProductSet === AUSPOST_PRODUCT_SET.PARCEL_CONTRACT_PRODUCTS
    ) {
      message.error('Account Number is required.');
      return false;
    }
    if (
      (!auspostMerchantToken || auspostMerchantToken === '') &&
      auspostProductSet === AUSPOST_PRODUCT_SET.MY_POST_BUSINESS
    ) {
      message.error('Merchant Token is required.');
      return false;
    }
    if (!labelPassword || labelPassword === '') {
      message.error('Password is required.');
      return false;
    }
    return true;
  };

  getPayload = () => {
    const {
      id,
      active,
      labelApiKey,
      labelAccountNumber,
      labelPassword,
      auspostProductSet,
      auspostMerchantToken,
    } = this.state;
    return {
      id,
      active,
      labelApiKey,
      labelAccountNumber: auspostProductSet === AUSPOST_PRODUCT_SET.PARCEL_CONTRACT_PRODUCTS
        ? labelAccountNumber
        : null,
      labelPassword,
      labelService: LABEL_SERVICE,
      auspostProductSet,
      auspostMerchantToken:
        auspostProductSet === AUSPOST_PRODUCT_SET.MY_POST_BUSINESS ? auspostMerchantToken : null,
    };
  };

  handleOk = async () => {
    this.setState({
      loading: true,
    });
    if (!this.validateFields()) {
      this.setState({
        loading: false,
      });
      return;
    }
    const payload = this.getPayload();
    trackingVitally('rr_Australia Post_integrated');
    try {
      const response = await axios.post('/api/carrierSettings/update', payload);
      console.log(response);
      message.success(
        'Australia Post integration has been successfully updated.',
        5
      );
      this.props.setModalVisible(null);
    } catch (err) {
      this.setState({
        loading: false,
      });
      return message.error('something went wrong please try again', 5);
    }
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  render() {
    return (
      <Modal
        title="Set up your Australia Post integration"
        visible={true}
        width="50%"
        onOk={this.handleOk}
        confirmLoading={this.state.confirmLoading}
        onCancel={() => this.props.setModalVisible(null)}
      >
        <Row type="flex" justify="space-around" align="middle" style={{ marginBottom: '20px' }}>
          <Col xs={24} md={10}>
            <h4 data-intercom-target="account-number-heading-integrations-carriers-australia-post">
              Product Set
            </h4>
            <span>
              Select the product set you want to use for your Australia Post
              integration.
            </span>
          </Col>
          <Col xs={24} md={10}>
            <Select
              onChange={(value) =>
                this.handleChange('auspostProductSet', value)
              }
              value={this.state.auspostProductSet}
              style={{ width: '100%' }}
            >
              <Option
                value={AUSPOST_PRODUCT_SET.PARCEL_CONTRACT_PRODUCTS}
                key={AUSPOST_PRODUCT_SET.PARCEL_CONTRACT_PRODUCTS}
              >
                Parcel Contract Products
              </Option>
              <Option value={AUSPOST_PRODUCT_SET.MY_POST_BUSINESS} key={AUSPOST_PRODUCT_SET.MY_POST_BUSINESS}>
                MyPost Business
              </Option>
            </Select>
          </Col>
        </Row>

        {this.state.auspostProductSet === AUSPOST_PRODUCT_SET.MY_POST_BUSINESS && (
          <Row type="flex" justify="space-around" align="middle">
            <Col xs={24} md={10}>
              <h4>Merchant Token</h4>
              <span>
                Enter your Merchant Token for MyPost Business products here.
              </span>
            </Col>
            <Col xs={24} md={10}>
              <Input
                value={this.state.auspostMerchantToken}
                onChange={(e) => {
                  this.handleChange('auspostMerchantToken', e.target.value);
                }}
                className="u-marginRight--none"
              />
            </Col>
          </Row>
        )}
        {this.state.auspostProductSet === AUSPOST_PRODUCT_SET.PARCEL_CONTRACT_PRODUCTS && (
          <Row type="flex" justify="space-around" align="middle">
            <Col xs={24} md={10}>
              <h4>Account number</h4>
              <span>
                Enter your account number for eParcel and International products
                here.
              </span>
            </Col>
            <Col xs={24} md={10}>
              <Input
                value={this.state.labelAccountNumber}
                onChange={(e) => {
                  this.handleChange('labelAccountNumber', e.target.value);
                }}
                className="u-marginRight--none"
                data-intercom-target="account-number-input-integrations-carriers-australia-post"
              />
            </Col>
          </Row>
        )}
        <Row type="flex" justify="space-around" align="middle">
          <Col xs={24} md={10}>
            <h4 data-intercom-target="api-key-heading-integrations-carriers-australia-post">
              API Key
            </h4>
            <span>
              Enter your API-Key here. Click on the link at the top to see where
              to find it.
            </span>
          </Col>
          <Col xs={24} md={10}>
            <a
              href="https://developers.auspost.com.au/apis/st-registration"
              target="_blank"
              rel="noopener noreferrer"
            >
              You can request your Australia Post API-Key here
            </a>
            <br />
            {/* {this.props.inputFieldValidation === false && (
              <p style={{ color: '#f00000' }}>
                API key cannot contain "API", "test", "sandbox" or special
                characters
              </p>
            )} */}
            <Input
              name="labelApiKey"
              onChange={(e) => {
                this.handleChange('labelApiKey', e.target.value);
              }}
              value={this.state.labelApiKey}
              className="u-marginRight--none u-marginTop--sm"
              data-intercom-target="api-key-input-integrations-carriers-australia-post"
            />
          </Col>
        </Row>
        <br />
        <Row type="flex" justify="space-around" align="middle">
          <Col xs={24} md={10}>
            <h4 data-intercom-target="password-heading-integrations-carriers-australia-post">
              Password
            </h4>
            <span>
              Enter the password of your Australia Post API account here.
            </span>
          </Col>
          <Col xs={24} md={10}>
            <Input
              type="password"
              value={this.state.labelPassword}
              onChange={(e) => {
                this.handleChange('labelPassword', e.target.value);
              }}
              className="u-marginRight--none"
              data-intercom-target="password-input-integrations-carriers-australia-post"
            />
          </Col>
        </Row>
      </Modal>
    );
  }
}

export default AuspostModal;
